import React, {Component} from 'react'
import {Col, Row} from 'react-bootstrap'

const UploadHistoryField = ({label, children}) => {
    return (
        <Row>
            <Col md={6}>
                {label || ''}
                {label && label != '' && label ? ':' : ''}
            </Col>
            <Col md={6}>
                {children || ''}
            </Col>
        </Row>
    );
};

export default UploadHistoryField;


// WEBPACK FOOTER //
// ./src/components/admin/data-import/upload-history-field.jsx